import React, { Fragment, useState } from 'react';
import { Grid, TextField, IconButton, Menu, MenuItem } from '@mui/material';
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import AgyleButton from '../../ui/buttons/agyleButton';
import AgyleAccordion from '../../ui/accordion/agyleAccordion';
import SmartViewStep from './SmartViewStep';

const SmartViewItem = ({
    view,
    viewIndex,
    expanded,
    onExpand,
    onUpdateName,
    onDeleteView,
    onDuplicateView,
    onShareView,
    onResetView,
    onAddStep,
    displayImagePref,
    viewDisplay,
    onSetTest,
    onSetHistory,
    onSetView,
    onDeleteStep,
    onSetDefault,
    onResetDefault,
    isDefault,
    onOpenDisplayDialog,
    filterDictType,
    classesBodyStyle,
    onSave,
    isChanged
}) => {

    // Menu state
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };

    const handleMenuClose = (event) => {
        setAnchorEl(null);
        if (event) event.stopPropagation();
    };

    const getTestForView = (viewItem) => {
        let tests = [];
        viewItem.steps?.forEach((step) => {
            if (Array.isArray(step.test)) {
                step.test.forEach((testName) => {
                    tests.push({
                        type: "test",
                        name: testName,
                        isDefault: isDefault({ name: testName }, viewItem.id)
                    });
                })
                tests.push({
                    type: "separator"
                })
            } else {
                tests.push({
                    type: "test",
                    name: step.test,
                    isDefault: false
                });
            }
        });
        return tests;
    };

    const renderHeader = () => {
        return <div style={{ alignItems: "center", display: "flex", flexWrap: "wrap", paddingRight: 40, marginTop: 15 }} >
            {getTestForView(view).map((test, index) => {
                if (test.type === "separator") {
                    return <div key={index + "sep"} style={{
                        width: 2,
                        height: 14,
                        marginRight: 10,
                        backgroundColor: 'white',
                        marginBottom: -6
                    }} />
                } else {
                    return <div key={index + "test"}
                        style={{
                            marginRight: 10,
                            background: test.isDefault ? '#2180f7' : '#494B4C',
                            padding: '4px 6px',
                            borderRadius: 6,
                            marginTop: 5,
                            width: "max-content"
                        }}>
                        {test.name}
                    </div>;
                }
            })}
            {view.shared_by_user && <div style={{ marginLeft: "auto", fontSize: 12, color: "#ACAFB3", marginTop: 15 }}>
                Shared by: <b> {view.shared_by_user} </b> (ver.<b> {view.version}</b>)
            </div>
            }
            {!view.shared_by_user && <div style={{ marginLeft: "auto", fontSize: 12, color: "#ACAFB3", marginTop: 15 }}>
                (ver.<b> {view.version}</b>)
            </div>
            }
            <IconButton onClick={handleMenuClick}
                style={{
                    marginTop: -37,
                    position: "absolute",
                    right: 40,
                }}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id={"grouped-menu" + view.id}
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                        sx: {
                            py: 0,
                        },
                    },
                }}
            >
                {!view?.is_shared &&
                    <MenuItem onClick={(e) => { handleMenuClose(e); onShareView(view); }}>
                        <ShareIcon style={{ marginRight: 10 }} />
                        Share with...
                    </MenuItem>
                }
                <MenuItem onClick={(e) => { handleMenuClose(e); onDuplicateView(view); }}>
                    <ContentCopyIcon style={{ marginRight: 10 }} />
                    Make a copy
                </MenuItem>
                {view?.is_shared && <MenuItem onClick={(e) => { handleMenuClose(e); onResetView(view); }}>
                    <RestartAltIcon style={{ marginRight: 10 }} />
                    Reset to original
                </MenuItem>
                }
                <MenuItem onClick={(e) => { handleMenuClose(e); onDeleteView(view.id); }}>
                    <DeleteIcon style={{ marginRight: 10, color: "#E25B61" }} />
                    Remove
                </MenuItem>
            </Menu>
        </div>
    };

    return (
        <AgyleAccordion
            key={viewIndex}
            label={view.name}
            secondLine={renderHeader()}
            expanded={expanded}
            onChange={onExpand}
            formBackground={false}
            bodyStyle={classesBodyStyle}
        >
            <div style={{ borderBottom: "1px solid #626466", padding: 20 }} key={viewIndex + "SV"}>
                <Grid container spacing={1}>
                    <Grid item xs={11}>
                        <TextField
                            value={view.name}
                            onChange={(e) => onUpdateName(e.target.value)}
                            label={"Name"}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={1}>
                        {/*<div style={{ textAlign: "center" }}>*/}
                        {/*    <IconButton*/}
                        {/*        size="small"*/}
                        {/*        disableRipple={true}*/}
                        {/*        onClick={() => {*/}
                        {/*            onDeleteView(viewIndex)*/}
                        {/*        }}>*/}
                        {/*        <DeleteIcon />*/}
                        {/*    </IconButton>*/}
                        {/*</div>*/}
                    </Grid>
                    {view.steps?.map((step, index) => {
                        return <SmartViewStep
                            key={index}
                            step={step}
                            index={index}
                            options={filterDictType(view)}
                            displayImagePref={displayImagePref}
                            viewDisplay={viewDisplay}
                            onSetTest={(val) => onSetTest(index, view.id, val)}
                            onSetHistory={(val) => onSetHistory(index, view.id, val)}
                            onSetView={(test, val) => onSetView(test, val)}
                            onDelete={() => onDeleteStep(index, view.id)}
                            onSetDefault={(opt) => onSetDefault(opt, view.id)}
                            onResetDefault={(opt) => onResetDefault(opt, view.id)}
                            isDefault={(opt) => isDefault(opt, view.id)}
                            onOpenDisplayDialog={() => onOpenDisplayDialog(view.id)}
                        />
                    })}
                    <Grid item xs={10}>
                        <AgyleButton
                            size="small"
                            onClick={() => onAddStep(view.id)}
                            style={{ borderRadius: 20 }}
                        >
                            Add Tab
                        </AgyleButton>
                    </Grid>
                    {isChanged && (
                        <Fragment>
                            <Grid item xs={1} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <AgyleButton
                                    size="small"
                                    color="primary"
                                    onClick={onSave}
                                    style={{ borderRadius: 20 }}
                                >
                                    Save
                                </AgyleButton>
                            </Grid>
                            <Grid item xs={1} />
                        </Fragment>
                    )}
                </Grid>
            </div>
        </AgyleAccordion>
    );
}

export default SmartViewItem;
